import type { EmailCategory } from './emails';

export interface ReplyTemplate {
  id: string;
  body: string;
}

/** A research-driven reply: only one option matches the truth in game data. */
export interface ReplyOption {
  id: string;
  body: string;
  correct: boolean;
}

export interface ReplyChallenge {
  /** Where in the game state the player needs to look. Italic hint above options. */
  lookupHint: string;
  options: readonly ReplyOption[];
}

/** 2-3 canned responses per category an AR clerk might actually send.
 *  These exist so Reply can compose a real message instead of being a no-op. */
export const REPLY_TEMPLATES: Record<EmailCategory, ReplyTemplate[]> = {
  cfo: [
    { id: 'cfo-pulling', body: 'Pulling the DSO impact now. Will have it by 11.' },
    { id: 'cfo-acme', body: 'Acme is at $42K 90+. Talking collections referral with Marcus today.' },
    { id: 'cfo-need-time', body: 'Still researching. Can we sync at 2?' },
  ],
  'customer-reply': [
    { id: 'cust-confirmed', body: 'Confirmed receipt. Applying to your account now.' },
    { id: 'cust-route-ap', body: 'Thanks — routing this to our AP team.' },
    { id: 'cust-need-remit', body: 'Could you send remittance advice so I can apply this correctly?' },
  ],
  'dispute-followup': [
    { id: 'disp-routing', body: 'Acknowledged. Routing to the PO team for review.' },
    { id: 'disp-credit', body: 'Credit memo issued today. Should reflect in 2 business days.' },
    { id: 'disp-pending', body: 'Still waiting on internal review. Will update tomorrow.' },
  ],
  internal: [
    { id: 'int-got-it', body: 'Got it, thanks.' },
    { id: 'int-will-do', body: 'Will do.' },
    { id: 'int-after-lunch', body: 'Can we sync after lunch?' },
  ],
  hr: [
    { id: 'hr-confirmed', body: 'Confirmed.' },
    { id: 'hr-thanks', body: 'Got it, thanks.' },
    { id: 'hr-looking', body: 'Looking now.' },
  ],
  voicemail: [
    { id: 'vm-calling-back', body: 'Calling back now.' },
    { id: 'vm-eod', body: 'Will reach out before EOD.' },
    { id: 'vm-followup', body: 'Got your message. I&apos;ll follow up shortly.' },
  ],
  spam: [], // Reply isn't offered for spam.
};
